import { NavLink, Outlet, useNavigate } from 'react-router-dom'
import { useAuth } from '../auth/AuthContext'

export function Layout() {
  const { user, logout } = useAuth()
  const navigate = useNavigate()

  async function handleLogout() {
    await logout()
    navigate('/login', { replace: true })
  }

  return (
    <div className="app">
      <header className="app-header">
        <div className="brand">Time Tracker</div>

        <nav className="nav">
          <NavLink to="/" end>Home</NavLink>
          <NavLink to="/projects">Projects</NavLink>
          {user?.role === 'manager' && (
            <>
              <NavLink to="/reports">Reports</NavLink>
              <NavLink to="/users">Users</NavLink>
            </>
          )}
        </nav>

        {user && (
          <div className="user">
            {user.picture && <img src={user.picture} alt="" className="avatar" />}
            <span className="user-name">{user.name}</span>
            {user.role === 'manager' && <span className="badge">Manager</span>}
            <button type="button" className="link" onClick={handleLogout}>
              Sign out
            </button>
          </div>
        )}
      </header>

      <main className="app-main">
        <Outlet />
      </main>
    </div>
  )
}
